import { adminHttpClient } from '../../commons/adminHttpClient'
import PagedList from '../../commons/PagedList'
import SuppressionReason from '../../../domain/suppressionList/suppressionReason'

export type SuppressionListItemResponse = {
  id: string
  createdAt: string
  emailAddress: string
  reason: SuppressionReason
}

export type SuppressionListFilter = {
  pageNumber: number
  pageSize: number
  orderColumn: string
  orderDescending: boolean
  reason?: SuppressionReason
  emailAddress?: string
}

export const searchSuppressionList = (
  filter: SuppressionListFilter,
): Promise<PagedList<SuppressionListItemResponse>> => {
  filter = filter || {
    pageNumber: 1,
    pageSize: 25,
    orderColumn: 'createdAt',
    orderDescending: false,
  }
  return adminHttpClient.get('/csi/SuppressionList/Search', filter)
}
